export const makeApiLeadUrl = (path: String): string =>
  `https://api.getsirena.com/v1${path}`;
